export enum DOCUMENT_REQUEST_STATUS {
	PENDING = 'pending',
	IN_PROGRESS = 'in-progress',
	COMPLETED = 'completed',
	ON_HOLD = 'on-hold',
	CANCELED = 'canceled',
}

export enum DOCUMENT_REQUEST_INTERNAL_STATUS {
	PENDING = 'pending',
	IN_PROGRESS = 'in-progress',
	COMPLETED = 'completed',
	ON_HOLD = 'on-hold',
	CANCELED = 'canceled',
	READY_FOR_REVIEW = 'ready-for-review',
	READY_FOR_UPLOAD = 'ready-for-upload',
}

export enum DOCUMENT_REQUEST_DOCUMENT_STATUS {
	PENDING = 'pending',
	ASSIGNED = 'assigned',
	IN_PROGRESS = 'in-progress',
	COMPLETED = 'completed',
	READY_FOR_UPLOAD = 'ready-for-upload',
	ON_HOLD = 'on-hold',
	CANCELED = 'canceled',
}

export enum DOCUMENT_REQUEST_PRIORITY {
	HIGH = 'high',
	MEDIUM = 'medium',
	LOW = 'low',
}

export interface DocumentRequest {
	id?: string;
	createdAt?: number;
	updatedAt?: number;
	createdBy: string;
	updatedBy: string;
	businessId: string;
	status: DOCUMENT_REQUEST_STATUS;
	internalStatus: DOCUMENT_REQUEST_INTERNAL_STATUS;
	requestType: string;
	note?: string;
	assignedTo?: string;
	documents?: DocumentRequestDocument[];
	documentsCount?: number;
	statusHistory: DocumentRequestStatusHistory[];
	completeBefore?: number;
	priority?: DOCUMENT_REQUEST_PRIORITY;
}

export interface DocumentRequestDocument {
	id?: string;
	name: string;
	size: number;
	contentType: string;
	storagePath: string;
	googleDriveLink: string;
	status: DOCUMENT_REQUEST_DOCUMENT_STATUS;
	statusHistory: DocumentRequestStatusHistory[];
	assignedTo?: string;
	displayName?: string;
	note?: string;
	parentId?: string;
	docRefPath?: string;
}

export interface DocumentRequestStatusHistory {
	status:
		| DOCUMENT_REQUEST_DOCUMENT_STATUS
		| DOCUMENT_REQUEST_STATUS
		| DOCUMENT_REQUEST_INTERNAL_STATUS;
	timestamp: number;
	updatedBy: string;
	isInternal: boolean;
}
